import React from 'react';

import { TServices } from 'types/services';

export const ServicesContext = React.createContext<null | TServices>(null);
